import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

const useStyles = makeStyles(theme => ({
  container: {
    backgroundColor: theme.palette.neutral.lightest,
    height: 50,
    width: '100vw',
    padding: theme.spacing(2),
  },
  text: {
    width: 'min-content',
    fontSize: '0.875rem',
    marginLeft: 10,
    textAlign: 'left',
    lineHeight: 1.2,
    color: theme.palette.text.default,

    [theme.breakpoints.up('sm')]: {
      marginLeft: 7,
      fontSize: theme.typography.h4.fontSize,
      width: 'max-content',
    },
  },
}));

const badges = [
  {
    icon: {
      id: '6TykeNVERK88y5eYTpXE',
      alt: 'Lock',
    },
    text: 'Secure Checkout',
  },
  {
    icon: {
      id: 'OVgPAK90R6WB7rkzZ8N7',
      alt: 'Calendar',
    },
    text: 'Flexible Reservation',
  },
  {
    icon: {
      id: '1r4Ehz7WSk6qYVgraGje',
      alt: 'Star',
    },
    text: 'Trusted Reviews',
  },
];

function TrustBanner() {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <Box display="flex" justifyContent="space-around" margin="0 auto" width="100%" maxWidth="550px">
        {badges.map(({ icon: { id, alt }, text }) => (
          <Box key={text} display="flex" alignItems="center" justifyContent="center">
            <img src={`https://media.graphcms.com/${id}`} alt={alt} />
            <Typography className={classes.text} variant="body2">
              {text}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}

export default TrustBanner;
